import { AfterViewInit, Component, OnDestroy, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { WorkerAgreementStatusEnum } from 'src/app/models/enums/worker-agreement-status-enum';
import { WorkerFormStatusEnum } from 'src/app/models/enums/WorkerFormStatusEnum';
import { WorkerStatusEnum } from 'src/app/models/enums/WorkerStatusEnum';
import { WorkedDaysDataSource } from './worked-days.datasource';

@Component({
  selector: 'app-worked-days',
  templateUrl: './worked-days.component.html',
  styleUrls: ['./worked-days.component.scss'],
  providers: [WorkedDaysDataSource],
  standalone: false
})
export class WorkedDaysComponent implements AfterViewInit, OnDestroy {
  dataSource = inject(WorkedDaysDataSource);
  private route = inject(ActivatedRoute);
  private translateService = inject(TranslateService);

  WorkerAgreementStatusEnum = WorkerAgreementStatusEnum;
  WorkerStatusEnum = WorkerStatusEnum;
  WorkerFormStatusEnum = WorkerFormStatusEnum;

  displayedColumns: string[] = [
    'employerName',
    'workedDays',
    'workerAgreementWorkedDays',
    'employmentHistoryWorkedDays',
    'calculationDate'
  ];

  areFiltersExpanded: boolean = false;

  private readonly unsubscribe$ = new Subject<void>();
  private workerId: number;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor() {
    this.workerId = +this.route.parent.snapshot.params.workerId;
  }

  ngAfterViewInit() {
    merge(this.sort.sortChange, this.translateService.onLangChange)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page, this.translateService.onLangChange)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(() => this.fetchData()),
      )
      .subscribe();

    this.fetchData();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  private fetchData = () =>
    this.dataSource.workedDaysSubject.next({
      WorkerId: this.workerId,
      Page: this.paginator.pageIndex + 1,
      Count: this.paginator.pageSize,
      SortingField: this.sort.active,
      SortingDirection: this.sort.direction,
    });
}
